/** Client HTTP Karaté R0 — cookies session (BT-KR0-019). */
const MUTATION_HEADER = { "X-Requested-With": "karate-r0" };

/**
 * @param {string} path
 * @param {RequestInit} [options]
 */
export async function karateR0Fetch(path, options = {}) {
  const headers = new Headers(options.headers);
  if (!headers.has("Accept")) headers.set("Accept", "application/json");
  if (!headers.has("Content-Type") && options.body) {
    headers.set("Content-Type", "application/json");
  }
  if (options.method && options.method !== "GET" && options.method !== "HEAD") {
    for (const [key, value] of Object.entries(MUTATION_HEADER)) {
      headers.set(key, value);
    }
  }

  const response = await fetch(path, {
    ...options,
    headers,
    credentials: "include",
  });

  const contentType = response.headers.get("content-type") ?? "";
  const body = contentType.includes("application/json")
    ? await response.json().catch(() => null)
    : null;

  return { response, body };
}

export async function karateR0Login(email, password) {
  return karateR0Fetch("/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });
}

export async function karateR0Me() {
  return karateR0Fetch("/auth/me");
}

export async function karateR0Logout() {
  return karateR0Fetch("/auth/logout", { method: "POST" });
}

export async function karateR0ChangePassword({ currentPassword, newPassword, confirmPassword }) {
  return karateR0Fetch("/auth/change-password", {
    method: "POST",
    body: JSON.stringify({ currentPassword, newPassword, confirmPassword }),
  });
}
